"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Credits = _interopRequireDefault(require("../Credits"));

var _References = _interopRequireDefault(require("@healthwise-ui/core/References"));

var _KeyGen = require("@healthwise-ui/core/KeyGen");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 19px 0 0;\n\n  & p {\n    font-size: 0.8em;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  background: transparent;\n  border: none;\n  color: #017acd;\n  cursor: pointer;\n\n  &:hover,\n  &:focus {\n    outline: 2px #017acd solid;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 16px;\n  padding: 0 4px 4px 0;\n  & svg {\n    width: 100%;\n  }\n  & svg path {\n    fill: #017acd;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SpanIcon = _styledComponents.default.span(_templateObject());

var Button = _styledComponents.default.button(_templateObject2());

var Div = _styledComponents.default.div(_templateObject3());

var CreditsAndReferences = /*#__PURE__*/function (_Component) {
  _inherits(CreditsAndReferences, _Component);

  var _super = _createSuper(CreditsAndReferences);

  function CreditsAndReferences(props) {
    var _this;

    _classCallCheck(this, CreditsAndReferences);

    _this = _super.call(this, props);
    _this.toggleCredits = _this.toggleCredits.bind(_assertThisInitialized(_this));
    _this.getIcon = _this.getIcon.bind(_assertThisInitialized(_this));
    _this.renderRegion = _this.renderRegion.bind(_assertThisInitialized(_this));
    _this.state = {
      showCredits: false
    };
    return _this;
  }

  _createClass(CreditsAndReferences, [{
    key: "toggleCredits",
    value: function toggleCredits() {
      this.setState({
        showCredits: !this.state.showCredits
      });
    }
  }, {
    key: "getIcon",
    value: function getIcon(id) {
      if (this.state.showCredits) {
        return /*#__PURE__*/_react.default.createElement(SpanIcon, null, /*#__PURE__*/_react.default.createElement("title", null, "Close"), /*#__PURE__*/_react.default.createElement("svg", {
          role: "presentation",
          focusable: "false",
          xmlns: "http://www.w3.org/2000/svg",
          width: "10",
          height: "5",
          viewBox: "0 0 10 5"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 5l5-5 5 5",
          fillRule: "evenodd"
        })));
      }

      return /*#__PURE__*/_react.default.createElement(SpanIcon, null, /*#__PURE__*/_react.default.createElement("svg", {
        role: "presentation",
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "5",
        viewBox: "0 0 10 5"
      }, /*#__PURE__*/_react.default.createElement("title", null, "Open"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 0H0l5 5",
        fillRule: "evenodd"
      })));
    }
  }, {
    key: "renderRegion",
    value: function renderRegion(id) {
      var _this$props = this.props,
          asOfDate = _this$props.asOfDate,
          credits = _this$props.credits,
          references = _this$props.references,
          referencesLabel = _this$props.referencesLabel;
      var template = '';
      var referenceElement = references && references.length ? /*#__PURE__*/_react.default.createElement(_References.default, {
        references: references,
        referencesLabel: referencesLabel
      }) : null;
      template = this.state.showCredits || this.props.readOnly ? /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        role: "region",
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-expanded": this.state.showCredits
      }, /*#__PURE__*/_react.default.createElement(_Credits.default, {
        asOfDate: asOfDate,
        credits: credits
      }), referenceElement) : '';
      return template;
    }
  }, {
    key: "render",
    value: function render() {
      var creditsId = this.props.id || (0, _KeyGen.getKey)();
      var toggleButton = this.props.readOnly ? /*#__PURE__*/_react.default.createElement("h3", null, this.props.buttonLabel) : /*#__PURE__*/_react.default.createElement(Button, {
        "aria-controls": creditsId,
        type: "button",
        onClick: this.toggleCredits
      }, this.getIcon(), /*#__PURE__*/_react.default.createElement("span", null, this.props.buttonLabel));
      return /*#__PURE__*/_react.default.createElement(Div, null, /*#__PURE__*/_react.default.createElement("div", null, toggleButton), this.renderRegion(creditsId));
    }
  }]);

  return CreditsAndReferences;
}(_react.Component);

CreditsAndReferences.defaultProps = {
  buttonLabel: 'Credits and References'
};
CreditsAndReferences.propTypes = {
  id: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  asOfDate: _propTypes.default.string,
  buttonLabel: _propTypes.default.string,
  credits: _propTypes.default.object,
  referencesLabel: _propTypes.default.string,
  references: _propTypes.default.array
};
var _default = CreditsAndReferences;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/CreditsAndReferences/index.js